<p-table [rowHover]="true" #dt dataKey="Id"  [value]="families" styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm">
	<ng-template pTemplate="header">
		<tr>
			<th colspan="2">Famille client</th>
			<th colspan="3">Espace pro</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
		<tr>
			<td>{{row.Id}}</td>
			<td>{{row.Caption}}</td>

			<td><p-radioButton (onClick)="updateNetwork(row)" label="Aucun" name="xx_Espace_Pro" [value]="null" [(ngModel)]="row.xx_Espace_Pro"></p-radioButton></td>
			<td><p-radioButton (onClick)="updateNetwork(row)" label="Classique" name="xx_Espace_Pro" [value]="'classique'" [(ngModel)]="row.xx_Espace_Pro"></p-radioButton></td>
			<td><p-radioButton (onClick)="updateNetwork(row)" label='GSS' name="xx_Espace_Pro" [value]="'gss'" [(ngModel)]="row.xx_Espace_Pro"></p-radioButton></td>
		</tr>
	</ng-template>
</p-table>
